import { DemographicModel } from 'api/dto/Demographic.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'demographic';

export namespace DemographicState {
  export type Demographics = DemographicModel[];
  export type DryListResource = Resource<Demographics>;
  export type ListResource = Resource<Demographics>;

  export type Domain = {
    dryListResource: ListResource;
    listResource: ListResource;
    reportListResource: ListResource;
  };

  export const INITIAL_DOMAIN: Domain = {
    dryListResource: Resource.createPendingResource(),
    listResource: Resource.createPendingResource(),
    reportListResource: Resource.createPendingResource(),
  };
}

export type DemographicState = {
  demographic?: DemographicState.Domain;
};
